import React from "react";

const PopupFileSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="127"
    height="152"
    viewBox="0 0 127 152"
    fill="none"
  >
    <path
      d="M63.2443 142.256C98.1731 142.256 126.489 113.941 126.489 79.0118C126.489 44.083 98.1731 15.7676 63.2443 15.7676C28.3154 15.7676 0 44.083 0 79.0118C0 113.941 28.3154 142.256 63.2443 142.256Z"
      fill="white"
    />
    <path
      d="M63.2443 142.256C98.1731 142.256 126.489 113.941 126.489 79.0118C126.489 44.083 98.1731 15.7676 63.2443 15.7676C28.3154 15.7676 0 44.083 0 79.0118C0 113.941 28.3154 142.256 63.2443 142.256Z"
      fill="#017972"
      fillOpacity="0.15"
    />
    <g filter="url(#filter0_d_1441_12868)">
      <path
        d="M99.502 52.0273H26.9819C24.6533 52.0273 22.7656 53.915 22.7656 56.2436V144.786C22.7656 147.114 24.6533 149.002 26.9819 149.002H99.502C101.831 149.002 103.718 147.114 103.718 144.786V56.2436C103.718 53.915 101.831 52.0273 99.502 52.0273Z"
        fill="white"
      />
    </g>
    <path
      d="M65.2821 64.6777H33.9686C31.9731 64.6777 30.3555 65.8104 30.3555 67.2075C30.3555 68.6047 31.9731 69.7373 33.9686 69.7373H65.2821C67.2775 69.7373 68.8952 68.6047 68.8952 67.2075C68.8952 65.8104 67.2775 64.6777 65.2821 64.6777Z"
      fill="#DFEAFB"
    />
    <path
      d="M86.9606 75.6484H33.9686C31.9731 75.6484 30.3555 76.7811 30.3555 78.1782C30.3555 79.5754 31.9731 80.708 33.9686 80.708H86.9606C88.9561 80.708 90.5737 79.5754 90.5737 78.1782C90.5737 76.7811 88.9561 75.6484 86.9606 75.6484Z"
      fill="#DFEAFB"
    />
    <path
      d="M65.2879 87.4395H33.9744C31.979 87.4395 30.3613 88.5721 30.3613 89.9692C30.3613 91.3664 31.979 92.499 33.9744 92.499H65.2879C67.2834 92.499 68.901 91.3664 68.901 89.9692C68.901 88.5721 67.2834 87.4395 65.2879 87.4395Z"
      fill="#DFEAFB"
    />
    <path
      d="M86.9665 98.4102H33.9744C31.979 98.4102 30.3613 99.5428 30.3613 100.94C30.3613 102.337 31.979 103.47 33.9744 103.47H86.9665C88.962 103.47 90.5796 102.337 90.5796 100.94C90.5796 99.5428 88.962 98.4102 86.9665 98.4102Z"
      fill="#DFEAFB"
    />
    <path
      d="M65.2821 110.219H33.9686C31.9731 110.219 30.3555 111.351 30.3555 112.749C30.3555 114.146 31.9731 115.278 33.9686 115.278H65.2821C67.2775 115.278 68.8952 114.146 68.8952 112.749C68.8952 111.351 67.2775 110.219 65.2821 110.219Z"
      fill="#DFEAFB"
    />
    <path
      d="M86.9606 121.189H33.9686C31.9731 121.189 30.3555 122.322 30.3555 123.719C30.3555 125.116 31.9731 126.249 33.9686 126.249H86.9606C88.9561 126.249 90.5737 125.116 90.5737 123.719C90.5737 122.322 88.9561 121.189 86.9606 121.189Z"
      fill="#DFEAFB"
    />
    <g filter="url(#filter1_d_1441_12868)">
      <path
        d="M99.5059 9H26.9858C24.6572 9 22.7695 10.8877 22.7695 13.2163V38.514C22.7695 40.8426 24.6572 42.7303 26.9858 42.7303H99.5059C101.834 42.7303 103.722 40.8426 103.722 38.514V13.2163C103.722 10.8877 101.834 9 99.5059 9Z"
        fill="#016D5B"
      />
    </g>
    <path
      d="M54.8119 18.2734H32.8872C31.49 18.2734 30.3574 19.4061 30.3574 20.8032C30.3574 22.2004 31.49 23.333 32.8872 23.333H54.8119C56.209 23.333 57.3416 22.2004 57.3416 20.8032C57.3416 19.4061 56.209 18.2734 54.8119 18.2734Z"
      fill="#B4DAFF"
    />
    <path
      d="M69.9905 29.2441H32.8872C31.49 29.2441 30.3574 30.3768 30.3574 31.7739C30.3574 33.1711 31.49 34.3037 32.8872 34.3037H69.9905C71.3876 34.3037 72.5203 33.1711 72.5203 31.7739C72.5203 30.3768 71.3876 29.2441 69.9905 29.2441Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_1441_12868"
        x="16.7656"
        y="43.0273"
        width="92.9531"
        height="108.975"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1441_12868"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1441_12868"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1441_12868"
        x="16.7695"
        y="0"
        width="92.9531"
        height="45.7305"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1441_12868"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1441_12868"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default PopupFileSvg;
